// IK1 · Stängd beta: Qid-kontot är inloggat men har inget Qvenari-konto än (API:t svarar
// invite_required). Tokens behålls men användaren sätts inte, och InviteCodeGate ber om koden.
// Egen modul utan beroenden så att api.ts kan använda den. Koden kontrolleras bara i API:t.

const PENDING_KEY = 'qvenari_invite_required';
const MARK_INVITE_KEY = 'qvenari_pending_mark_invite';
export const INVITE_REQUIRED_EVENT = 'qvenari:invite-required';

export class InviteRequiredError extends Error {
  constructor(message = 'Ange din invitekod för att skapa ett konto.') {
    super(message);
    this.name = 'InviteRequiredError';
  }
}

/** Svarade API:t att kontot saknas (403 med invite_required)? */
export function isInviteRequiredBody(body: unknown): boolean {
  return !!body && typeof body === 'object' && ((body as { invite_required?: unknown }).invite_required === true || (body as { code?: unknown }).code === 'invite_required');
}

/** Kallas från inloggningen och /auth/me; visar InviteCodeGate. */
export function requestInviteCode(): void {
  try { sessionStorage.setItem(PENDING_KEY, '1'); } catch { /* privat läge */ }
  window.dispatchEvent(new Event(INVITE_REQUIRED_EVENT));
}

export function inviteCodePending(): boolean {
  try { return sessionStorage.getItem(PENDING_KEY) === '1'; } catch { return false; }
}

export function clearInviteCodeRequest(): void {
  try { sessionStorage.removeItem(PENDING_KEY); } catch { /* privat läge */ }
}

/** Inbjudningslänken till en mark (?invite=…) — släpper in utan kod. Överlever omdirigeringen via Qid. */
export function rememberMarkInvite(token: string): void {
  try { sessionStorage.setItem(MARK_INVITE_KEY, token); } catch { /* privat läge */ }
}

export function pendingMarkInvite(): string | null {
  try { return sessionStorage.getItem(MARK_INVITE_KEY); } catch { return null; }
}
